import type { Uuid } from "@/domains/global/identifiers";
import { resolveSyncModelNamespacedUuid } from "@/modules/uuid/sync-models/resolveSyncModelNamespacedUuid";
import { SyncModelKind } from "@/store/sync/types";

export const resolveAssistantTaskNoteReferenceSyncModelUuid = ({
  taskId,
  noteId,
}: {
  taskId: Uuid;
  noteId: Uuid;
}): Uuid => {
  return resolveSyncModelNamespacedUuid({
    modelKind: { value: SyncModelKind.AssistantTaskNoteReference },
    uuids: [taskId, noteId],
  });
};
